import { AnchorButton } from "@rootreeweb/ui";

import image from "@/assets/holiday-cards/holiday-card-monday-motivation.png";
import { DayDefinition } from "../DayDefinition.js";

/** Class Monday_Motivations Represents the Monday Motivations card. */
export class Monday_Motivations extends DayDefinition {
	/** The CSS class to use for the card. */
	public className = "hl:bg-dirt2022";
	public image = image;
	/** The slug for the card. Used to identify the card for css, etc. */
	public slug = "monday-motivation";

	/** Get the display for the card in English. */
	public initENCard(): void {
		this.title = "Monday Motivation";
		this.content = (
			<>
				<AnchorButton
					className={"hl:mx-auto hl:no-underline"}
					colour={"white"}
					download
					href="https://rootree.ca/wp-content/uploads/2022/11/MotivationalMonday-Eng.pdf"
					target="_blank"
				>
					Download PDF
				</AnchorButton>
				<br />
				<br />
				<p className="hl:whitespace-pre-line">
					{`Every Monday at Rootree, our Director of HR sends out an email.
					Reminding us to take a moment for ourselves, to inhale and to exhale.
					She sends us motivational videos, and poems for us to read.
					It truly is appreciated and often just what we need.
					We all know that the holiday season is more than snowy days & elves.
					It’s a season of giving and sharing and reflecting on ourselves.
					As we end the year and a new one is about to start.
					Here are some sweet links for a clearer	mind and a lighter heart.`}
				</p>
			</>
		);
	}

	/** Get the display for the card in French. */
	public initFRCard(): void {
		this.title = "Nos conseils pour vous motiver le Lundi";
		this.content = (
			<>
				<AnchorButton
					className={"hl:mx-auto hl:no-underline"}
					colour={"white"}
					download={true}
					href="https://rootree.ca/wp-content/uploads/2022/11/MotivationalMonday-Eng.pdf"
					target="_blank"
				>
					Téléchargez le PDF
				</AnchorButton>
				<p className="hl:whitespace-pre-line">{`*En anglais uniquement.`}</p>
				<br />
				<p className="hl:whitespace-pre-line">
					{`Chez Rootree, tous les lundis notre directrice des ressources humaines nous envoie un e-mail
					Et nous rappelle que prendre soin de nous n'est pas une activité optionnelle
					Elle nous envoie des vidéos inspirantes et des poèmes dès la première heure
					De précieux conseils appréciés à leur juste valeur !
					Bien sûr, les vacances de Noël ne se résument pas qu'à la neige ou aux lutins
					Au contraire ! La saison est propice à l'entraide, au partage et à la mise en commun
					Comme une année se termine et qu'une autre s'apprête à commencer
					Voici quelques liens utiles pour avoir l'esprit serein et le cœur léger`}
				</p>
			</>
		);
	}
}
